import { createCustomEnum } from "./customEnum";

export type TidTabsType =
	| "unassigned"
	| "in-progress"
	| "pended"
	| "complete"
	| "qa-unassigned"
	| "qa-complete"
	| "qa-in-progress";

const TidTabs = createCustomEnum({
	Unassigned: {
		value: 1,
		name: "unassigned",
		displayName: "Unassigned",
	},
	InProgress: {
		value: 2,
		name: "in-progress",
		displayName: "In Progress",
	},
	Pended: {
		value: 3,
		name: "pended",
		displayName: "Pended",
	},
	Complete: {
		value: 4,
		name: "complete",
		displayName: "Complete",
	},
	QAUnassigned: {
		value: 5,
		name: "qa-unassigned",
		displayName: "QA Unassigned",
	},
	QAComplete: {
		value: 6,
		name: "qa-complete",
		displayName: "QA Complete",
	},
	QAInProgress: {
		value: 7,
		name: "qa-in-progress",
		displayName: "QA In Progress",
	},
});

export default TidTabs;

export const TidInProgressTabs = [
	TidTabs.InProgress,
	TidTabs.Pended,
	TidTabs.QAInProgress,
];

export const TidCompleteTabs = [TidTabs.Complete, TidTabs.QAComplete];
